export default (fieldName, newValue, functions) => {
  functions.setFieldTouched(fieldName, true)
  functions.setFieldValue(fieldName, newValue)
}
